// This file is AUTOGENERATED, do not edit it manually!!!

export const menu = {
    access_levels: 'Access levels',
    activityList: 'Activity center',
    addlicenses: 'Add licenses',
    approvals: 'Approval requests',
    archive: 'Archive',
    billingReport: 'Billing Report',
    builder: 'Builder',
    commonReports: 'Common Reports',
    companySettings: 'Company settings',
    customers: 'Customers',
    customfields: 'Custom fields',
    dashboard: 'Dashboard',
    days_left: '1#Trial ends in {0} day#Trial ends in {0} days',
    featurelabs: 'Feature labs',
    forms: 'Custom forms',
    generalOptions: 'Account settings',
    guestPortal: 'Guest portal',
    integrations: 'Automations',
    invoices: 'Invoices',
    jobroles: 'Job roles',
    logout: 'Logout',
    mobile_apps: 'Mobile apps',
    myassignments: 'My assignments',
    myoptions: 'My settings',
    mySettingsNotifications: 'Notifications',
    mySettingsOptions: 'Advanced settings',
    mySettingsProfile: 'Profile',
    myvacations: 'My vacations',
    notificationCenter: 'Notifications',
    notifications: 'Notification settings',
    payrollReport: 'Payroll Report',
    portfolios: 'Portfolios',
    powerbi: 'BI dashboards',
    presetsHideViewTooltip: 'Hide view',
    presetsListTitle: 'Saved views',
    projectCentricView: 'Project centric view',
    ratecards: 'Rate cards',
    recommend_us: 'Referral program',
    reportgenerator: 'Custom Report',
    reports: 'Reports',
    resourcesPage: 'Resources',
    roles: 'Roles',
    search: 'Search',
    sharedProjectPlans: 'Shared project snapshots',
    space: 'Space settings',
    spaces: 'Spaces',
    summaryReport: 'Time Logs Summary Report',
    support_center: 'Support center',
    support_chat: 'Support chat',
    systemLists: 'System lists',
    timelogs: 'Time logs',
    updateLicense: 'Update License',
    upgrade_now: 'Upgrade now',
    users: 'Users',
    vacationsreport: 'Vacations',
    whatif: 'Resource Loading Simulation',
    workflows: 'Workflows',
};
